module.exports = __webpack_public_path__ + "static/media/005-Wechseln_ID_32.b7424787.mp3";